import Image from "next/image";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import {
  HOW_PERSONA,
  HOW_PERSONA_AVATAR_SIZE,
  HOW_PERSONA_MORE_THEMES,
  HOW_PERSONA_QUERIES,
  HOW_PERSONA_THEMES,
  personaDots,
  personaShare,
  withCount,
} from "./HowItWorks.logic";
import styles from "./HowItWorksMock.module.css";

export default function HowItWorksMockPersona() {
  const T = useT();

  return (
    <div className={styles.card}>
      <div className={styles.identity}>
        <span className={styles.stack}>
          {HOW_PERSONA.photos.map((photo) => (
            <Image
              key={photo}
              className={styles.stackAvatar}
              src={photo}
              alt=""
              width={HOW_PERSONA_AVATAR_SIZE}
              height={HOW_PERSONA_AVATAR_SIZE}
              unoptimized
            />
          ))}
        </span>
        <span className={styles.rowTexts}>
          <span className={styles.customerName}>{T(TKey.HOME_MEIDLY_HOW_PERSONA_NAME)}</span>
          <span className={styles.meta}>
            {withCount(T(TKey.HOME_MEIDLY_HOW_PERSONA_CUSTOMERS), HOW_PERSONA.customers)}
          </span>
        </span>
        <span className={styles.badge}>
          {withCount(T(TKey.HOME_MEIDLY_HOW_PERSONA_WIN_RATE), HOW_PERSONA.winRate)}
        </span>
      </div>

      <div className={styles.themes}>
        {HOW_PERSONA_THEMES.map((theme) => (
          <span key={theme.labelKey} className={styles.theme}>
            <span className={UStyles.classNames(styles.tag, styles[theme.toneClass])}>
              {T(theme.tagKey)}
            </span>
            <span className={styles.themeText}>{T(theme.labelKey)}</span>
            <span className={styles.dots}>
              {personaDots(theme.value).map((dot) => (
                <span
                  key={dot.id}
                  className={UStyles.classNames(
                    styles.dot,
                    dot.isFilled ? styles[theme.dotClass] : "",
                  )}
                />
              ))}
            </span>
            <span className={styles.themeShare}>
              {personaShare(T(TKey.HOME_MEIDLY_HOW_PERSONA_SHARE), theme.value)}
            </span>
          </span>
        ))}
        <span className={styles.theme}>
          <span className={UStyles.classNames(styles.tag, styles.tagMore)}>
            {HOW_PERSONA_MORE_THEMES}
          </span>
          <span className={styles.themeMore}>{T(TKey.HOME_MEIDLY_HOW_PERSONA_MORE)}</span>
        </span>
      </div>

      <div className={styles.queries}>
        {HOW_PERSONA_QUERIES.map((query) => (
          <div key={query.titleKey} className={styles.query}>
            <span className={styles.label}>{T(query.titleKey)}</span>
            <span className={styles.criteria}>
              {query.criteria.map((criterion) => (
                <span key={criterion.valueKey} className={styles.criterion}>
                  <span className={styles.criterionKey}>{T(criterion.labelKey)}</span>
                  <span className={styles.criterionValue}>{T(criterion.valueKey)}</span>
                </span>
              ))}
              <span className={UStyles.classNames(styles.tag, styles.tagMore, styles.criteriaMore)}>
                +{query.moreCount}
              </span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
